export default function () {
  return {
    agreements: [],
    agreement: {},
    listStatus: [],
    listType: [],
    histories: []
  }
}
